import Vue from 'vue';
import Vuex from 'vuex';
import moduleMenus from './modules/menus';
import moduleEvents from './modules/events';
import moduleAppointments from './modules/appointments';
import moduleUser from './modules/heimbasUser';
import moduleNews from './modules/news';
import moduleAuth from './modules/auth';


Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        packageVersion: process.env.PACKAGE_VERSION || '0'
    },
      getters: {
        appVersion: (state) => {
          return state.packageVersion
        }
    },
    modules: {
        moduleMenus: moduleMenus,
        moduleAuth: moduleAuth,
        moduleEvents: moduleEvents,
        moduleNews: moduleNews,
        moduleAppointments: moduleAppointments,
        moduleUser: moduleUser,
    }
})

export default store;